import {call, put, takeLatest} from 'redux-saga/effects';
import {
  getPatientsRequest,
  getPatientsFailure,
  getPatientsSuccess,
  getSpecialistsRequest,
  getSpecialistsSuccess,
  getSpecialistsFailure,
  getAdminsRequest,
  getAdminsSuccess,
  getAdminsFailure,
  addAdminRequest,
  addAdminSuccess,
  addAdminFailure,
  deleteAdminRequest,
  deleteAdminSuccess,
  deleteAdminFailure,
  updateAdminRequest,
  updateAdminSuccess,
  updateAdminFailure,
  updateUserRecordFailure,
  updateUserRecordRequest,
  updateUserRecordSuccess,
  getAuditLogsRequest,
  getAuditLogsSuccess,
  getAuditLogsFailure,
  // get access control roles api
  getAccessControlRolesFailure,
  getAccessControlRolesRequest,
  getAccessControlRolesSuccess,
  // get access control access modules api
  getAccessControlAccessModulesFailure,
  getAccessControlAccessModulesRequest,
  getAccessControlAccessModulesSuccess,
  // update role api
  updateRoleFailure,
  updateRoleRequest,
  updateRoleSuccess,

  // get licence verification mode api
  getLicenceVerificationModeFailure,
  getLicenceVerificationModeRequest,
  getLicenceVerificationModeSuccess,

  // toggle licence verification api
  toggleLicenceVerificationFailure,
  toggleLicenceVerificationRequest,
  toggleLicenceVerificationSuccess,
  // get access modules list api
  getAccessModulesListFailure,
  getAccessModulesListRequest,
  getAccessModulesListSuccess,
} from '../slices/superAdminDashboardSlice';
import {getPatients, getSpecialists, getAdmins, addAdmin, deleteAdmin, updateAdmin, updateUserRecord, getAuditLogs, getAdminRoles, getAdminAccessModules, updateRole, toggleLicenceVerification, getLicenceVerificationMode, getAllAccessModules} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* getPatientsSaga(action: any): Generator {
  try {
    const response: any = yield call(getPatients, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getPatientsSuccess(response.data));
    } else {
      yield put(getPatientsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getPatientsFailure(error.response));
  }
}

function* getSpecialistsSaga(action: any): Generator {
  try {
    const response: any = yield call(getSpecialists, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistsSuccess(response.data));
    } else {
      yield put(getSpecialistsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistsFailure(error.response));
  }
}

function* getAdminsSaga(action: any): Generator {
  try {
    const response: any = yield call(getAdmins, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAdminsSuccess(response.data));
    } else {
      yield put(getAdminsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAdminsFailure(error.response));
  }
}

function* addAdminSaga(action: any): Generator {
  try {
    const response: any = yield call(addAdmin, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(addAdminSuccess(response.data));
    } else {
      yield put(addAdminFailure(response.data));
    }
  } catch (error: any) {
    yield put(addAdminFailure(error.response));
  }
}

function* deleteAdminSaga(action: any): Generator {
  try {
    const response: any = yield call(deleteAdmin, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(deleteAdminSuccess(response.data));
    } else {
      yield put(deleteAdminFailure(response.data));
    }
  } catch (error: any) {
    yield put(deleteAdminFailure(error.response));
  }
}

function* updateAdminSaga(action: any): Generator {
  try {
    const response: any = yield call(updateAdmin, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateAdminSuccess(response.data));
    } else {
      yield put(updateAdminFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateAdminFailure(error.response));
  }
}

function* updateUserRecordSaga(action: any): Generator {
  try {
    const response: any = yield call(updateUserRecord, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateUserRecordSuccess(response.data));
    } else {
      yield put(updateUserRecordFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateUserRecordFailure(error.response));
  }
}

function* getAuditLogsSaga(action: any): Generator {
  try {
    const response: any = yield call(getAuditLogs, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAuditLogsSuccess(response.data));
    } else {
      yield put(getAuditLogsFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAuditLogsFailure(error.response));
  }
}

function* getAdminRolesSaga(action: any): Generator {
  try {
    const response: any = yield call(getAdminRoles, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAccessControlRolesSuccess(response.data));
    } else {
      yield put(getAccessControlRolesFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAccessControlRolesFailure(error.response));
  }
}

function* getAdminAccessModulesSaga(action: any): Generator {
  try {
    const response: any = yield call(getAdminAccessModules, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAccessControlAccessModulesSuccess(response.data));
    } else {
      yield put(getAccessControlAccessModulesFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAccessControlAccessModulesFailure(error.response));
  }
}

function* updateRoleSaga(action: any): Generator {
  try {
    const response: any = yield call(updateRole, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(updateRoleSuccess(response.data));
    } else {
      yield put(updateRoleFailure(response.data));
    }
  } catch (error: any) {
    yield put(updateRoleFailure(error.response));
  }
}

function* getLicenceVerificationModeSaga(): Generator {
  try {
    const response: any = yield call(getLicenceVerificationMode);
    if (response?.data?.status === SUCCESS_KEY) {
      yield put(getLicenceVerificationModeSuccess(response.data));
    } else {
      yield put(getLicenceVerificationModeFailure(response?.data || {status: 'error', status_code: 'E-10001'}));
    }
  } catch (error: any) {
    yield put(getLicenceVerificationModeFailure(error?.response?.data || error?.response || {status: 'error', status_code: 'E-10001'}));
  }
}

function* toggleLicenceVerificationSaga(action: any): Generator {
  try {
    const response: any = yield call(toggleLicenceVerification, action.payload);
    if (response?.data?.status === SUCCESS_KEY) {
      yield put(toggleLicenceVerificationSuccess(response.data));
    } else {
      yield put(toggleLicenceVerificationFailure(response?.data || {status: 'error', status_code: 'E-10001'}));
    }
  } catch (error: any) {
    yield put(toggleLicenceVerificationFailure(error?.response?.data || error?.response || {status: 'error', status_code: 'E-10001'}));
  }
}

function* getAccessModulesListSaga(): Generator {
  try {
    const response: any = yield call(getAllAccessModules);
    if (response?.data?.status === SUCCESS_KEY) {
      yield put(getAccessModulesListSuccess(response.data));
    } else {
      yield put(getAccessModulesListFailure(response?.data || {status: 'error', status_code: 'E-10001'}));
    }
  } catch (error: any) {
    yield put(getAccessModulesListFailure(error?.response?.data || error?.response || {status: 'error', status_code: 'E-10001'}));
  }
}

export default function* superAdminDashboardSaga(): Generator {
  yield takeLatest(getSpecialistsRequest.type, getSpecialistsSaga);
  yield takeLatest(getPatientsRequest.type, getPatientsSaga);
  yield takeLatest(getAdminsRequest.type, getAdminsSaga);
  yield takeLatest(addAdminRequest.type, addAdminSaga);
  yield takeLatest(deleteAdminRequest.type, deleteAdminSaga);
  yield takeLatest(updateAdminRequest.type, updateAdminSaga);
  yield takeLatest(updateUserRecordRequest.type, updateUserRecordSaga);
  yield takeLatest(getAuditLogsRequest.type, getAuditLogsSaga);
  yield takeLatest(getAccessControlRolesRequest.type, getAdminRolesSaga);
  yield takeLatest(getAccessControlAccessModulesRequest.type, getAdminAccessModulesSaga);
  yield takeLatest(updateRoleRequest.type, updateRoleSaga);
  yield takeLatest(getLicenceVerificationModeRequest.type, getLicenceVerificationModeSaga);
  yield takeLatest(toggleLicenceVerificationRequest.type, toggleLicenceVerificationSaga);
  yield takeLatest(getAccessModulesListRequest.type, getAccessModulesListSaga);
}
